<div class="pal-balance-container">
  <div class="pal-balance-title" data-testid="balance.type">
    <div *ngIf="displayTooltip; else noTooltip" class="tooltip" [ngClass]="{'tooltip-first': balance.type === 'Outstanding Loan(s)'}">
      <div class="pal-balance-tooltip-label" [innerText]="balance.type"></div>
      <div class="tooltiptext">{{tooltipVerbiage}}</div>
    </div>
    <ng-template #noTooltip>
      <span [innerText]="balance.type"></span>
    </ng-template>
  </div>
  <div class="pal-balance-amount" data-testid="pal-balance-amount-">{{isNumber(balance.amount) ? (balance.amount | currency) : balance.amount}}</div>
</div>
